<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<h1 mat-dialog-title>{{ title }}</h1>
<div class="message-text">{{ message }}</div>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-around center">
  <div>
    <button
      mat-stroked-button
      *ngIf="buttonTrueText !== ''"
      hotkeyAction="ENTER"
      (click)="onClick(true)"
      tabindex="3"
    >
      {{ buttonTrueText }}
    </button>
  </div>
  <button mat-stroked-button (click)="onCancel()" tabindex="3">
    {{ buttonFalseText }}
  </button>
</mat-dialog-actions>
